import React from 'react';
import { MessageSquare } from 'lucide-react';
import ChannelConfigsManagement from './ChannelConfigsManagement';

const SlackConfigsManagement = () => (
  <ChannelConfigsManagement
    icon={MessageSquare}
    title="Slack"
    subtitle="Manage Slack channel configurations for each store"
    apiPrefix="/admin/slack-config"
    tokenLabel="Bot Token"
    tokenFieldName="botToken"
    recipientLabel="Channel ID"
    recipientFieldName="channel"
  />
);

export default SlackConfigsManagement;
